export default "__VITE_ASSET__BvvSHKJg__"